import React from 'react';
import IconTitlePair from './SubComponents/IconTitlePair/IconTitlePair';

const InfoPanelTitle = ({titleIcon, title, titleExtraInfo}) => {
  return (
    <div className='info-panel-title-container'>
      <IconTitlePair titleIcon={titleIcon} title={title} />
      {titleExtraInfo && <span className='info-panel-title-extra-info'>{titleExtraInfo}</span>}
    </div>
  );
}

export default InfoPanelTitle;
